<template>
  <div class="student-name">
    <i v-if="gender === 1" class="anyteachicon anyteach-male blue" />
    <i v-if="gender === 2" class="anyteachicon anyteach-female red" />
    <span>{{ name_full }}</span>
    <span v-if="age && !hideAge" class="age">{{ age }}</span>
  </div>
</template>

<script>
export default {
  props: {
    name_full: {
      type: String,
      default: ""
    },
    age: {
      type: Number,
      default: 0
    },
    gender: {
      type: Number,
      default: 0
    },
    hideAge: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style lang="scss" scoped>
.student-name {
  i {
    margin-right: 3px;
  }
  .age {
    margin-left: 5px;
    opacity: 0.5;
  }
}
</style>